export function TextIn({ edit, value, onValue, label, area, placeholder, testId, maxLength = 300, list }) {
  const Tag = area ? "textarea" : "input";
  return (
    <div>
      {label && <label className="label">{label}</label>}
      <Tag className={`input ${area ? "py-2 min-h-[64px] resize-y" : ""}`} value={value ?? ""} placeholder={placeholder} maxLength={maxLength} list={list}
        onFocus={edit.begin} onBlur={edit.end} onChange={(e) => edit.live((p) => onValue(p, e.target.value))} data-testid={testId} />
    </div>
  );
}

export function NumIn({ edit, value, onValue, label, step = 0.1, min = 0, max = 60, testId, suffix = "s" }) {
  return (
    <div>
      {label && <label className="label">{label}</label>}
      <div className="relative">
        <input type="number" inputMode="decimal" className="input pr-8" value={value} step={step} min={min} max={max}
          onChange={(e) => { const v = parseFloat(e.target.value); if (!Number.isNaN(v)) edit.set((p) => onValue(p, Math.min(max, Math.max(min, Math.round(v * 100) / 100)))); }} data-testid={testId} />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-500">{suffix}</span>
      </div>
    </div>
  );
}

export function SelectIn({ value, onChange, options, label, testId }) {
  return (
    <div>
      {label && <label className="label">{label}</label>}
      <select className="input" value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}
